import { useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

import { dashboardQueryOptions } from './dashboard-query-options';
import {
  type AccountsReceivableStudentGroup,
  type Label,
} from './get-accounts-receivable-student-grouping';

export interface GetManualAccountsReceivableStudentGroupingParams {
  range?: Label;
  enabled?: boolean;
}

export const getManualAccountsReceivableStudentGroupingAPI = async (
  params?: GetManualAccountsReceivableStudentGroupingParams,
) => {
  const response = await baseAPI.get<Array<AccountsReceivableStudentGroup>>(
    '/dashboard/metrics/account-receivable/manual/student-grouping',
    {
      params: {
        range: params?.range,
      },
    },
  );
  return response.data;
};

export const useGetManualAccountsReceivableStudentGrouping = (
  params?: GetManualAccountsReceivableStudentGroupingParams,
) => {
  const { enabled = true, ...apiParams } = params ?? {};
  return useQuery({
    ...dashboardQueryOptions,
    queryKey: [
      KEYS.MANUAL_ACCOUNTS_RECEIVABLE_STUDENT_GROUPING,
      apiParams.range,
    ],
    queryFn: () => getManualAccountsReceivableStudentGroupingAPI(apiParams),
    enabled,
  });
};
